module.exports = __webpack_public_path__ + "fonts/Barlow-Light.53ce411.woff2";